module.exports = __webpack_public_path__ + "static/media/20ECE18.5d031e45.jpg";